// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teacher-attendance-section {
  width: 1000px;
  min-height: 100vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 0;
  margin-bottom: 0;
  position: relative;
  transition: width 0.3s ease;
}

/* Стили для расширенного режима */
.teacher-attendance-section.expanded {
  width: 1200px !important;
}

/* Стили когда меню свернуто */
body.menu-collapsed .teacher-attendance-section {
  width: 1200px !important;
}

/* Заголовок */
.attendance-header {
  margin-bottom: 24px;
  padding: 0 8px;
  width: 100%;
}

.attendance-title-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.attendance-title {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1 1;
}

.group-title {
  font-size: 24px;
  font-weight: 600;
  color: #002FA7;
  margin: 0;
}

.subject-full-title {
  font-size: 16px;
  color: #64748b;
  font-weight: 400;
  line-height: 1.4;
  text-align: left;
  white-space: normal;
  word-wrap: break-word;
  max-width: 600px;
}

.attendance-actions {
  margin-left: auto;
  display: flex;
  gap: 16px;
  align-items: center;
}

/* Кнопки */
.gradient-btn {
  background: #002FA7 !important;
  color: white !important;
  border: none !important;
  padding: 13px 25px !important;
  border-radius: 13px !important;
  cursor: pointer !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  transition: all 0.2s ease !important;
  min-width: 180px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.gradient-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3);
}

.set-grades-btn {
  min-width: 140px;
}

/* Стили для заголовка с кнопками информации и обновления */
.attendance-cabinet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 16px;
}

.header-left-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Стили для кнопок в заголовке */
.header-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  color: #475569;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
}

.header-btn:hover {
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  border-color: #94a3b8;
  transform: translateY(-1px);
}

.header-btn:active {
  transform: translateY(0);
}

/* Базовые стили для всех тултипов */
.info-icon-btn {
  position: relative;
  display: inline-flex;
  align-items: left;
}

.info-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  transform: translateX(0%) translateY(8px);
  background: white;
  border: 1px solid #e0e7ff;
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
  overflow: hidden;
}

/* Размеры тултипов */
.info-tooltip.small {
  width: 320px;
  max-width: calc(80vw - 40px);
}

.info-tooltip.large {
  width: 320px;
  max-width: calc(100vw - 40px);
}

/* Стили контента остаются прежними */
.info-tooltip-content {
  color: #374151;
  font-size: 13px;
  line-height: 1.4;
  text-align: left;
  word-break: break-word;
  white-space: normal;
  overflow-y: auto;
  max-height: 50vh; 
  overflow-y: auto;
}

/* Остальные стили остаются без изменений */
.info-header {
  padding: 18px 20px 14px;
  background: linear-gradient(135deg, #f8fafc 0%, #f0f4ff 100%);
  border-bottom: 1px solid #e0e7ff;
}

.info-title h3 {
  margin: 0 0 6px 0;
  color: #002FA7;
  font-size: 16px;
  font-weight: 700;
}

.info-title p {
  margin: 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
}

.info-section {
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.info-section:last-child {
  border-bottom: none;
}

.info-section h4 {
  margin: 0 0 12px 0;
  color: #002FA7;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-section h4::before {
  content: '';
  width: 3px;
  height: 14px;
  background: #002FA7;
  border-radius: 2px;
}

.features-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  font-size: 13px;
  font-weight: 400;
}

.feature-icon {
  width: 6px;
  height: 6px;
  background: #002FA7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.statuses-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.status-demo {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  font-weight: 700;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}

.status-info span {
  color: #576374;
  font-size: 12px;
}

.status-present { background: #2cbb00; }
.status-absent { background: #f59e0b; }
.status-not { background: #ef4444; }
.status-empty {
  background: transparent;
  border: 1px solid #cbd5e1;
  color: #94a3b8;
  text-shadow: none;
}

.usage-steps {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.step {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
}

.step-number {
  width: 20px;
  height: 20px;
  background: #002FA7;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.step span:last-child {
  color: #374151;
  font-size: 12px;
  line-height: 1.4;
}

.step code {
  background: #f1f5f9;
  padding: 1px 4px;
  border-radius: 3px;
  font-family: 'Monaco', 'Consolas', monospace;
  font-size: 11px;
  color: #002FA7;
  font-weight: 600;
  border: 1px solid #e2e8f0;
}

.info-tip {
  padding: 12px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f0f4ff 100%);
  border-top: 1px solid #e0e7ff;
  color: #374151;
  font-size: 12px;
  line-height: 1.4;
}

/* Анимации */
@keyframes tooltipAppear {
  0% {
    opacity: 0;
    transform: translateX(0%) translateY(5px);
  }
  100% {
    opacity: 1;
    transform: translateX(0%) translateY(8px);
  }
}

.info-icon-btn:hover .info-tooltip,
.info-icon-btn:focus-within .info-tooltip {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateX(0%) translateY(8px);
  animation: tooltipAppear 0.3s ease;
}

.info-tooltip::before {
  content: '';
  position: absolute;
  top: -5px;
  left: 16px;
  transform: rotate(45deg);
  width: 10px;
  height: 10px;
  background: white;
  border-left: 1px solid #e0e7ff;
  border-top: 1px solid #e0e7ff;
  z-index: 1;
}

/* Адаптивность */
@media (max-width: 768px) {
  .info-tooltip.small,
  .info-tooltip.medium,
  .info-tooltip.large {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    min-width: 85vw; /* Увеличить минимальную ширину */
    max-width: 90vw;
    width: auto;
    max-height: 85vh; /* Ограничить высоту на мобильных */
  }
  
  .info-tooltip-content {
    max-height: 70vh; /* Уменьшить максимальную высоту контента на мобильных */
  }
  
  .info-header { padding: 16px 18px 12px; }
  .info-section { padding: 14px 18px; }
  .status-item { gap: 12px; padding: 8px; }
  .status-demo { width: 30px; height: 30px; font-size: 13px; }
  .step { gap: 8px; }
  .info-tip { padding: 12px 18px; }
}

@media (max-width: 480px) {
  .info-tooltip.small,
  .info-tooltip.medium,
  .info-tooltip.large {
    max-height: 90vh; /* Еще больше на очень маленьких экранах */
  }
  
  .info-tooltip-content {
    max-height: 80vh;
  }
  
  .info-title h3 { font-size: 15px; }
  .info-section h4 { font-size: 13px; }
  .feature-item, .status-item, .step { padding: 4px 0; }
  .status-demo { width: 28px; height: 28px; font-size: 12px; }
}

.info-tooltip-content::-webkit-scrollbar {
  width: 4px;
}

.info-tooltip-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 2px;
}

.info-tooltip-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.info-tooltip-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Стили для кнопки обновления */
.pc-refresh-btn {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pc-refresh-btn.pc-refreshing {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-color: #cbd5e1;
  color: #64748b;
  cursor: not-allowed;
}

.pc-refresh-icon {
  width: 18px;
  height: 18px;
  transition: all 0.3s ease;
  filter: brightness(0.8);
}

.pc-refresh-spin {
  animation: pc-spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  filter: brightness(1);
}

@keyframes pc-spin {
  0% { 
    transform: rotate(0deg);
    filter: brightness(0.8);
  }
  50% {
    filter: brightness(1.2);
  }
  100% { 
    transform: rotate(360deg);
    filter: brightness(0.8);
  }
}

/* Эффект пульсации для кнопки во время обновления */
.pc-refresh-btn.pc-refreshing::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .attendance-cabinet-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .header-btn {
    justify-content: center;
    width: 100%;
  }
  
  .info-tooltip {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    min-width: 280px;
    max-width: 90vw;
  }
  
  .info-icon-btn:hover .info-tooltip {
    opacity: 0;
    visibility: hidden;
  }
  
  .info-icon-btn:focus .info-tooltip,
  .info-icon-btn:active .info-tooltip {
    opacity: 1;
    visibility: visible;
  }
}

@media (max-width: 480px) {
  .header-btn {
    padding: 8px 12px;
    font-size: 13px;
  }
}

/* Стили для загрузки */
.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #e2e8f0;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-info {
  text-align: center;
  padding: 40px;
  color: #64748b;
  font-style: italic;
}

/* Стили для отсутствующей информации */
.no-info-available {
  text-align: center;
  padding: 30px;
  color: #64748b;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
}

.no-info-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.no-info-available h4 {
  margin: 0 0 12px 0;
  color: #475569;
}

.no-info-available p {
  margin: 0 0 20px 0;
  color: #64748b;
}

.debug-info {
  background: white;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  font-size: 0.875rem;
}

.debug-info p {
  margin: 4px 0;
  font-family: monospace;
}

/* Контент даты  */
.dates-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  margin-top: 34px;
  width: 100%;
}

.dates-title-new {
  font-weight: 600;
  color: #002c9c;
  font-size: 14px;
  text-align: center;
  line-height: 1.2;
}

.tas-lesson-id{
  font-size: 1px;
  font-weight: 100;
  color:transparent;
}

/* Стили для модального окна информации о занятии (посещаемость) */
.lesson-info-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(50, 64, 124, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.lesson-info-modal {
  background: white;
  border-radius: 12px;
  padding: 0;
  width: 95%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.lesson-info-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e2e8f0;
  background: white;
  border-radius: 12px 12px 0 0;
}

.lesson-info-modal-header h3 {
  margin: 0;
  color: #002FA7;
  font-size: 20px;
  font-weight: 600;
}

.lesson-info-modal-close {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 20px;
  cursor: pointer;
  color: #64748b;
  padding: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.lesson-info-modal-close:hover {
  background: #e2e8f0;
  color: #374151;
}

.lesson-info-modal-content {
  padding: 24px;
  background: white;
}

/* Детальная информация о занятии */
.lesson-details-info {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
}

.info-section-header {
  background: #f8fafc;
  color: #002FA7;
  margin: 0;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;
}

.info-section-content {
  padding: 14px;
}

/* ОДИНАКОВАЯ СЕТКА для деталей и статистики - 4 колонки */
.info-grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.info-grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  text-align: center;
  min-height: 80px;
  justify-content: center;
}

.info-grid-label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 8px;
  line-height: 1.2;
}

.info-grid-value {
  font-size: 16px;
  font-weight: 600;
  color: #002FA7;
}

/* Статистика посещаемости */
.attendance-stats-section {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
}

.attendance-stats-header {
  background: #f8fafc;
  color: #002FA7;
  margin: 0;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;
}

.attendance-stats-content {
  padding: 20px;
}

/* Процент посещаемости - отдельный блок */
.attendance-percentage {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #f0f4ff 0%, #e6f0ff 100%);
  border-radius: 8px;
  border: 1px solid #c7d2fe;
  margin-top: 16px;
}

.percentage-circle {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: conic-gradient(
    #002FA7 0% var(--percentage, 0%),
    #f1f5f9 var(--percentage, 0%) 100%
  );
}

.percentage-circle::before {
  content: '';
  position: absolute;
  width: 56px;
  height: 56px;
  background: white;
  border-radius: 50%;
}

.percentage-value {
  font-size: 18px;
  font-weight: 800;
  color: #002FA7;
  z-index: 1;
}

.percentage-label {
  font-size: 16px;
  font-weight: 600;
  color: #002FA7;
}

/* Стили для состояния загрузки */
.lesson-info-loading {
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
}

.lesson-info-loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f1f5f9;
  border-top: 3px solid #002FA7;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

.lesson-info-loading-text {
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
}

/* Стили для отсутствующей информации */
.lesson-info-no-data {
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
  margin: 20px 0;
}

.lesson-info-no-data-icon {
  font-size: 48px;
  margin-bottom: 16px;
  color: #cbd5e1;
}

.lesson-info-no-data h4 {
  margin: 0 0 12px 0;
  color: #475569;
  font-size: 18px;
  font-weight: 600;
}

.lesson-info-no-data p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.5;
}

/* Кнопки действий */
.lesson-info-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

/* Анимации */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .lesson-info-modal {
    width: 95%;
    margin: 20px;
    max-height: 95vh;
  }
  
  .lesson-info-modal-header {
    padding: 20px;
  }
  
  .lesson-info-modal-header h3 {
    font-size: 18px;
  }
  
  .lesson-info-modal-content {
    padding: 20px;
  }
  
  .info-grid-4 {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  
  .info-grid-item {
    padding: 16px 8px;
    min-height: 70px;
  }
  
  .info-grid-value {
    font-size: 16px;
  }
  
  .info-section-content,
  .attendance-stats-content {
    padding: 16px;
  }
  
  .attendance-percentage {
    flex-direction: column;
    gap: 12px;
    text-align: center;
    padding: 16px;
  }
  
  .percentage-circle {
    width: 60px;
    height: 60px;
  }
  
  .percentage-circle::before {
    width: 48px;
    height: 48px;
  }
  
  .percentage-value {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .lesson-info-modal-header {
    padding: 16px;
  }
  
  .lesson-info-modal-content {
    padding: 16px;
  }
  
  .info-grid-4 {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .info-grid-item {
    padding: 14px 8px;
    min-height: 65px;
  }
  
  .info-grid-value {
    font-size: 16px;
  }
  
  .percentage-circle {
    width: 50px;
    height: 50px;
  }
  
  .percentage-circle::before {
    width: 40px;
    height: 40px;
  }
  
  .percentage-value {
    font-size: 14px;
  }
}


/* Стили для состояния загрузки данных */
.loading-message {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
  font-size: 16px;
  background: white;
  border-radius: 12px;
  margin: 20px 0;
  border: 1px solid #e2e8f0;
}

.no-data-message {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
  font-size: 16px;
  background: white;
  border-radius: 12px;
  margin: 20px 0;
  border: 1px solid #e2e8f0;
}


/* Фильтры */
.attendance-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 8px;
  margin-bottom: 20px;
}

.date-range-filter {
  display: flex;
  align-items: center;
  gap: 12px;
}

.date-range-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.date-range-label {
  font-size: 14px;
  font-weight: 400;
  color: #64748b;
  white-space: nowrap;
}

.date-range-input {
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  color: #1e293b;
  background: white;
  cursor: pointer;
  min-width: 80px;
  transition: all 0.2s ease;
  height: 35px;
}

.date-range-input:focus {
  outline: none;
  border-color: #002FA7;
}

.subgroup-filter {
  display: flex;
  align-items: center;
  gap: 12px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-select {
  padding: 8px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  color: #1e293b;
  background: white;
  cursor: pointer;
  min-width: 160px;
  transition: all 0.2s ease;
  height: 35px;
}

.filter-select:focus {
  outline: none;
  border-color: #002FA7;
}

/* Контейнер таблицы */
.attendance-table-container {
  width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  overflow: hidden;
}

.attendance-table-wrapper {
  width: 100%;
  overflow-x: auto;
  position: relative;
}

.attendance-table {
  min-width: 100%;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

/* При расширенном режиме увеличиваем ширину таблицы */
.teacher-attendance-section.expanded .attendance-table,
body.menu-collapsed .attendance-table {
  min-width: 1200px;
}

.attendance-table th {
  background: white;
  color: #002c9c;
  font-size: 14px;
  font-weight: 500;
  padding: 16px 8px;
  text-align: center;
  border-bottom: 1px solid #e2e8f0;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 30;
}

/* Фиксированные заголовки */
.attendance-table th.column-number {
  position: sticky;
  left: 0;
  z-index: 50;
  background: #f8fafc;
  border-right: 2px solid #e2e8f0;
  border-bottom: 2px solid #e2e8f0;
}

.attendance-table th.column-name {
  position: sticky;
  left: 60px;
  z-index: 50;
  background: #f8fafc;
  border-right: 2px solid #e2e8f0;
  border-bottom: 2px solid #e2e8f0;
}

.attendance-table th.column-subgroup {
  position: sticky;
  left: 310px;
  z-index: 50;
  background: #f8fafc;
  border-right: 2px solid #e2e8f0;
  border-bottom: 2px solid #e2e8f0;
}

.attendance-table th.column-percentage {
  position: sticky;
  right: 0;
  z-index: 50;
  background: #f8fafc;
  border-left: 2px solid #e2e8f0;
  border-bottom: 2px solid #e2e8f0;
}

.attendance-table td {
  padding: 12px 8px;
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-align: center;
  height: 50px;
  position: relative;
  z-index: 1;
}



/* (аналогично успеваемости) */
.teacher-display {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.teacher-value {
  font-size: 14px;
  color: #002FA7;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.teacher-value:hover {
  background: #f0f4ff;
}

.teacher-edit-container {
  display: flex;
  align-items: center;
  gap: 4px;
}

.teacher-edit-input {
  border: 1px solid #002FA7;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
  width: 120px;
}

.teacher-edit-input:focus {
  outline: none;
  border-color: #002FA7;
}

.teacher-save-btn,
.teacher-cancel-btn {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 4px 6px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s ease;
}

.teacher-save-btn:hover {
  background: #2cbb00;
  color: white;
  border-color: #2cbb00;
}

.teacher-cancel-btn:hover {
  background: #ef4444;
  color: white;
  border-color: #ef4444;
}

.type-filters {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Фиксированные ячейки */
.attendance-table td.column-number {
  position: sticky;
  left: 0;
  z-index: 40;
  background: white;
  border-right: 2px solid #e2e8f0;
}

.attendance-table td.column-name {
  position: sticky;
  left: 60px;
  z-index: 40;
  background: white;
  border-right: 2px solid #e2e8f0;
  text-align: left !important;
}

.attendance-table td.column-subgroup {
  position: sticky;
  left: 310px;
  z-index: 40;
  background: white;
  border-right: 2px solid #e2e8f0;
}

.attendance-table td.column-percentage {
  position: sticky;
  right: 0;
  z-index: 40;
  background: white;
  border-left: 2px solid #e2e8f0;
}

/* Подсветка при наведении на строку */
.attendance-table tbody tr:hover td.column-number,
.attendance-table tbody tr:hover td.column-name,
.attendance-table tbody tr:hover td.column-subgroup,
.attendance-table tbody tr:hover td.column-percentage {
  background: #f0f4ff;
}

/* Конкретные размеры и позиции колонок */
.column-number {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
}

.column-name {
  width: 250px;
  min-width: 250px;
  max-width: 250px;
  text-align: left;
}

.column-subgroup {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}

.column-date {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  cursor: pointer;
  position: relative;
  z-index: 1;
}


.column-percentage {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

/* При расширенном режиме увеличиваем ширину некоторых колонок */
.teacher-attendance-section.expanded .column-name,
body.menu-collapsed .column-name {
  width: 300px;
  min-width: 300px;
  max-width: 300px;
}

.teacher-attendance-section.expanded .column-date,
body.menu-collapsed .column-date {
  width: 90px;
  min-width: 90px;
  max-width: 90px;
}

/* Стили для ячеек */
.cell-number {
  font-weight: 600;
  color: #002FA7;
  font-size: 14px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.cell-name {
  text-align: left !important;
  padding: 12px 16px !important;
  font-weight: 500;
  color: #1e293b;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cell-subgroup {
  font-weight: 500;
  color: #64748b;
  font-size: 13px;
  text-align: center;
}

.subgroup-select {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.subgroup-select:focus {
  outline: none;
  border-color: #002FA7;
}

/* стили для статусов посещаемости */
.cell-status-container {
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  text-align: center;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 100%;
}

.cell-status {
  height: 36px;
  width: 36px;
  border-radius: 8px;
  font-weight: 700;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.cell-status-container:hover .cell-status {
  transform: scale(1.15);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
}

.cell-status-container.editing {
  border: 2px solid #002FA7;
  border-radius: 6px;
  background: white;
}

/* Цвета для статусов */
.status-present {
  background: #2cbb00ff;
}

.status-absent {
  background: #f59e0b;
}

.status-sick {
  background: #6b7280;
}

.status-not {
  background: #ef4444;
}

.status-empty {
  background: transparent;
  border: 1px solid #cbd5e1;
  color: #cbd5e1;
  text-shadow: none;
}

.status-empty:hover {
  border-color: #002FA7;
  color: #002FA7;
  background: #f0f4ff;
}

/* Неактивные отчисленные/переведенные студенты в списке */

.student-inactive {
  background-color: #f8f9fa;
}

.student-inactive .cell-name {
  color: #9ca3af;
}

.inactive-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 6px;
  font-size: 10px;
  background-color: #9c9c9c;
  color: white;
  border-radius: 4px;
  text-transform: uppercase;
}

.cell-status-container.disabled {
  cursor: not-allowed;
}

.cell-status-container.disabled .cell-status {
  opacity: 0.5;
}

/* Стили для процента посещаемости студентов */
.cell-percentage {
  font-weight: 600;
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 20px;
  display: inline-block;
  min-width: 60px;
  text-align: center;
}

/* Inputs */
.status-input,
.date-input {
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  text-align: center;
  font-weight: 600;
  font-size: 13px;
  color: #1e293b;
  outline: none;
}

.status-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.date-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

/* Общая посещаемость группы */
.group-attendance-footer {
  padding: 16px 14px;
  background: transparent;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
}

.group-attendance-percentage {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: white;
  border-radius: 50px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.percentage-circle {
  width: 62px;
  height: 62px;  
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: conic-gradient(
    var(--percentage-color, #002FA7) 0% var(--percentage, 0%),
    #f1f5f9 var(--percentage, 0%) 100%
  );
}

.percentage-circle::before {
  content: '';
  position: absolute;
  width: 52px;
  height: 52px;
  background: white;
  border-radius: 50%;
  align-items: center;
}

.percentage-value {
  font-size: 15px; 
  font-weight: 800;
  z-index: 1;
  color: var(--percentage-color, #002FA7);
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.percentage-label {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  padding-right: 5px;
}

/* Двойной блок с процентами */
.double-percentage-footer {
  padding: 16px 14px;
  background: transparent;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.double-percentage-group {
  display: flex;
  align-items: center;
  gap: 20px;
}

.percentage-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: white;
  border-radius: 50px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.percentage-item-label {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
}

/* Модальные окна */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(50, 64, 124, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  min-width: 400px;
  max-width: 500px;
}

.modal-content h3 {
  margin: 0 0 16px 0;
  color: #002FA7;
  font-size: 18px;
}

.modal-content textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  resize: vertical;
  font-family: inherit;
  font-size: 14px;
  margin-bottom: 16px;
}

.modal-content textarea:focus {
  outline: none;
  border-color: #002FA7;
}

.date-inputs {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}

.date-input-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.date-input-group label {
  font-size: 14px;
  font-weight: 500;
  color: #002FA7;
}

.date-input-group input {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
}

.date-input-group input:focus {
  outline: none;
  border-color: #002FA7;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.cancel-btn {
  padding: 8px 16px;
  border: 2px solid #e2e8f0;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  color: #64748b;
  transition: all 0.2s ease;
}

.cancel-btn:hover {
  border-color: #64748b;
  background: #f8fafc;
}

/* Стили для скроллбара */
.attendance-table-wrapper::-webkit-scrollbar {
  height: 8px;
}

.attendance-table-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.attendance-table-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.attendance-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Адаптивность */
@media (max-width: 768px) {
  .teacher-attendance-section {
    width: 100%;
    min-width: 100%;
    padding: 12px;
  }
  
  .teacher-attendance-section.expanded,
  body.menu-collapsed .teacher-attendance-section {
    width: 100% !important;
  }
  
  .attendance-filters {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .attendance-title-container {
    flex-direction: column;
    gap: 16px;
  }
  
  .attendance-actions {
    justify-content: space-between;
    width: 100%;
  }
  
  .modal-content {
    min-width: 90vw;
    margin: 20px;
  }
  
  .date-inputs {
    flex-direction: column;
  }
  
  .column-name {
    width: 200px;
    min-width: 200px;
  }
  
  .column-number {
    width: 50px;
    min-width: 50px;
  }
  
  .column-subgroup {
    width: 80px;
    min-width: 80px;
  }
  
  .percentage-circle {
    width: 80px;
    height: 80px;
  }
  
  .percentage-circle::before {
    width: 64px;
    height: 64px;
  }
  
  .percentage-value {
    font-size: 16px;
  }
  
  .cell-status {
    height: 32px;
    width: 32px;
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/th-components/TeacherAttendanceSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,4DAA4D;EAC5D,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,wBAAwB;AAC1B;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,yCAAyC;EACzC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,2CAA2C;EAC3C,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,qCAAqC;AACrC;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB,mBAAmB,EAAE;AACvC,iBAAiB,mBAAmB,EAAE;AACtC,cAAc,mBAAmB,EAAE;AACnC;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE;;;IAGE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,SAAS;IACT,eAAe,EAAE,iCAAiC;IAClD,eAAe;IACf,WAAW;IACX,gBAAgB,EAAE,mCAAmC;EACvD;;EAEA;IACE,gBAAgB,EAAE,wDAAwD;EAC5E;;EAEA,eAAe,uBAAuB,EAAE;EACxC,gBAAgB,kBAAkB,EAAE;EACpC,eAAe,SAAS,EAAE,YAAY,EAAE;EACxC,eAAe,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;EAC3D,QAAQ,QAAQ,EAAE;EAClB,YAAY,kBAAkB,EAAE;AAClC;;AAEA;EACE;;;IAGE,gBAAgB,EAAE,0CAA0C;EAC9D;;EAEA;IACE,gBAAgB;EAClB;;EAEA,iBAAiB,eAAe,EAAE;EAClC,mBAAmB,eAAe,EAAE;EACpC,qCAAqC,cAAc,EAAE;EACrD,eAAe,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;AAC7D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA;EACE;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,8BAA8B;AAChC;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB;;;GAGC;AACH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,yCAAyC;AACzC;EACE;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;;AAGA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,sDAAsD;AACtD;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;;;AAIA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA,sCAAsC;AACtC;;;;EAIE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;;AAGA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,0DAA0D;;AAE1D;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA,WAAW;AACX;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB;;;GAGC;AACH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,uCAAuC;EACvC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,WAAW;IACX,eAAe;IACf,aAAa;EACf;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[".teacher-attendance-section {\n  width: 1000px;\n  min-height: 100vh;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  padding: 0;\n  margin-bottom: 0;\n  position: relative;\n  transition: width 0.3s ease;\n}\n\n/* Стили для расширенного режима */\n.teacher-attendance-section.expanded {\n  width: 1200px !important;\n}\n\n/* Стили когда меню свернуто */\nbody.menu-collapsed .teacher-attendance-section {\n  width: 1200px !important;\n}\n\n/* Заголовок */\n.attendance-header {\n  margin-bottom: 24px;\n  padding: 0 8px;\n  width: 100%;\n}\n\n.attendance-title-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.attendance-title {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  flex: 1;\n}\n\n.group-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #002FA7;\n  margin: 0;\n}\n\n.subject-full-title {\n  font-size: 16px;\n  color: #64748b;\n  font-weight: 400;\n  line-height: 1.4;\n  text-align: left;\n  white-space: normal;\n  word-wrap: break-word;\n  max-width: 600px;\n}\n\n.attendance-actions {\n  margin-left: auto;\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n/* Кнопки */\n.gradient-btn {\n  background: #002FA7 !important;\n  color: white !important;\n  border: none !important;\n  padding: 13px 25px !important;\n  border-radius: 13px !important;\n  cursor: pointer !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  transition: all 0.2s ease !important;\n  min-width: 180px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.gradient-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3);\n}\n\n.set-grades-btn {\n  min-width: 140px;\n}\n\n/* Стили для заголовка с кнопками информации и обновления */\n.attendance-cabinet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 16px;\n}\n\n.header-left-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Стили для кнопок в заголовке */\n.header-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  color: #475569;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n}\n\n.header-btn:hover {\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  border-color: #94a3b8;\n  transform: translateY(-1px);\n}\n\n.header-btn:active {\n  transform: translateY(0);\n}\n\n/* Базовые стили для всех тултипов */\n.info-icon-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: left;\n}\n\n.info-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform: translateX(0%) translateY(8px);\n  background: white;\n  border: 1px solid #e0e7ff;\n  border-radius: 12px;\n  padding: 0;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);\n  z-index: 1000;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n/* Размеры тултипов */\n.info-tooltip.small {\n  width: 320px;\n  max-width: calc(80vw - 40px);\n}\n\n.info-tooltip.large {\n  width: 320px;\n  max-width: calc(100vw - 40px);\n}\n\n/* Стили контента остаются прежними */\n.info-tooltip-content {\n  color: #374151;\n  font-size: 13px;\n  line-height: 1.4;\n  text-align: left;\n  word-break: break-word;\n  white-space: normal;\n  overflow-y: auto;\n  max-height: 50vh; \n  overflow-y: auto;\n}\n\n/* Остальные стили остаются без изменений */\n.info-header {\n  padding: 18px 20px 14px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f0f4ff 100%);\n  border-bottom: 1px solid #e0e7ff;\n}\n\n.info-title h3 {\n  margin: 0 0 6px 0;\n  color: #002FA7;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.info-title p {\n  margin: 0;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.info-section {\n  padding: 16px 20px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.info-section:last-child {\n  border-bottom: none;\n}\n\n.info-section h4 {\n  margin: 0 0 12px 0;\n  color: #002FA7;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.info-section h4::before {\n  content: '';\n  width: 3px;\n  height: 14px;\n  background: #002FA7;\n  border-radius: 2px;\n}\n\n.features-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 0;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.feature-icon {\n  width: 6px;\n  height: 6px;\n  background: #002FA7;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.statuses-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.status-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 10px;\n  background: #f8fafc;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s ease;\n}\n\n.status-demo {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  font-weight: 700;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n  flex-shrink: 0;\n}\n\n.status-info span {\n  color: #576374;\n  font-size: 12px;\n}\n\n.status-present { background: #2cbb00; }\n.status-absent { background: #f59e0b; }\n.status-not { background: #ef4444; }\n.status-empty {\n  background: transparent;\n  border: 1px solid #cbd5e1;\n  color: #94a3b8;\n  text-shadow: none;\n}\n\n.usage-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.step {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 0;\n}\n\n.step-number {\n  width: 20px;\n  height: 20px;\n  background: #002FA7;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.step span:last-child {\n  color: #374151;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.step code {\n  background: #f1f5f9;\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-family: 'Monaco', 'Consolas', monospace;\n  font-size: 11px;\n  color: #002FA7;\n  font-weight: 600;\n  border: 1px solid #e2e8f0;\n}\n\n.info-tip {\n  padding: 12px 20px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f0f4ff 100%);\n  border-top: 1px solid #e0e7ff;\n  color: #374151;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n/* Анимации */\n@keyframes tooltipAppear {\n  0% {\n    opacity: 0;\n    transform: translateX(0%) translateY(5px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0%) translateY(8px);\n  }\n}\n\n.info-icon-btn:hover .info-tooltip,\n.info-icon-btn:focus-within .info-tooltip {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n  transform: translateX(0%) translateY(8px);\n  animation: tooltipAppear 0.3s ease;\n}\n\n.info-tooltip::before {\n  content: '';\n  position: absolute;\n  top: -5px;\n  left: 16px;\n  transform: rotate(45deg);\n  width: 10px;\n  height: 10px;\n  background: white;\n  border-left: 1px solid #e0e7ff;\n  border-top: 1px solid #e0e7ff;\n  z-index: 1;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .info-tooltip.small,\n  .info-tooltip.medium,\n  .info-tooltip.large {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    margin: 0;\n    min-width: 85vw; /* Увеличить минимальную ширину */\n    max-width: 90vw;\n    width: auto;\n    max-height: 85vh; /* Ограничить высоту на мобильных */\n  }\n  \n  .info-tooltip-content {\n    max-height: 70vh; /* Уменьшить максимальную высоту контента на мобильных */\n  }\n  \n  .info-header { padding: 16px 18px 12px; }\n  .info-section { padding: 14px 18px; }\n  .status-item { gap: 12px; padding: 8px; }\n  .status-demo { width: 30px; height: 30px; font-size: 13px; }\n  .step { gap: 8px; }\n  .info-tip { padding: 12px 18px; }\n}\n\n@media (max-width: 480px) {\n  .info-tooltip.small,\n  .info-tooltip.medium,\n  .info-tooltip.large {\n    max-height: 90vh; /* Еще больше на очень маленьких экранах */\n  }\n  \n  .info-tooltip-content {\n    max-height: 80vh;\n  }\n  \n  .info-title h3 { font-size: 15px; }\n  .info-section h4 { font-size: 13px; }\n  .feature-item, .status-item, .step { padding: 4px 0; }\n  .status-demo { width: 28px; height: 28px; font-size: 12px; }\n}\n\n.info-tooltip-content::-webkit-scrollbar {\n  width: 4px;\n}\n\n.info-tooltip-content::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 2px;\n}\n\n.info-tooltip-content::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 2px;\n}\n\n.info-tooltip-content::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Стили для кнопки обновления */\n.pc-refresh-btn {\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.pc-refresh-btn.pc-refreshing {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-color: #cbd5e1;\n  color: #64748b;\n  cursor: not-allowed;\n}\n\n.pc-refresh-icon {\n  width: 18px;\n  height: 18px;\n  transition: all 0.3s ease;\n  filter: brightness(0.8);\n}\n\n.pc-refresh-spin {\n  animation: pc-spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n  filter: brightness(1);\n}\n\n@keyframes pc-spin {\n  0% { \n    transform: rotate(0deg);\n    filter: brightness(0.8);\n  }\n  50% {\n    filter: brightness(1.2);\n  }\n  100% { \n    transform: rotate(360deg);\n    filter: brightness(0.8);\n  }\n}\n\n/* Эффект пульсации для кнопки во время обновления */\n.pc-refresh-btn.pc-refreshing::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.4),\n    transparent\n  );\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .attendance-cabinet-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  \n  .header-btn {\n    justify-content: center;\n    width: 100%;\n  }\n  \n  .info-tooltip {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    margin: 0;\n    min-width: 280px;\n    max-width: 90vw;\n  }\n  \n  .info-icon-btn:hover .info-tooltip {\n    opacity: 0;\n    visibility: hidden;\n  }\n  \n  .info-icon-btn:focus .info-tooltip,\n  .info-icon-btn:active .info-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-btn {\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n}\n\n/* Стили для загрузки */\n.loading-spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #e2e8f0;\n  border-top: 2px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 10px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-info {\n  text-align: center;\n  padding: 40px;\n  color: #64748b;\n  font-style: italic;\n}\n\n/* Стили для отсутствующей информации */\n.no-info-available {\n  text-align: center;\n  padding: 30px;\n  color: #64748b;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px dashed #cbd5e1;\n}\n\n.no-info-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.no-info-available h4 {\n  margin: 0 0 12px 0;\n  color: #475569;\n}\n\n.no-info-available p {\n  margin: 0 0 20px 0;\n  color: #64748b;\n}\n\n.debug-info {\n  background: white;\n  padding: 12px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  font-size: 0.875rem;\n}\n\n.debug-info p {\n  margin: 4px 0;\n  font-family: monospace;\n}\n\n/* Контент даты  */\n.dates-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  margin-top: 34px;\n  width: 100%;\n}\n\n.dates-title-new {\n  font-weight: 600;\n  color: #002c9c;\n  font-size: 14px;\n  text-align: center;\n  line-height: 1.2;\n}\n\n.tas-lesson-id{\n  font-size: 1px;\n  font-weight: 100;\n  color:transparent;\n}\n\n/* Стили для модального окна информации о занятии (посещаемость) */\n.lesson-info-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(50, 64, 124, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.lesson-info-modal {\n  background: white;\n  border-radius: 12px;\n  padding: 0;\n  width: 95%;\n  max-width: 700px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.lesson-info-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: white;\n  border-radius: 12px 12px 0 0;\n}\n\n.lesson-info-modal-header h3 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.lesson-info-modal-close {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 20px;\n  cursor: pointer;\n  color: #64748b;\n  padding: 8px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.lesson-info-modal-close:hover {\n  background: #e2e8f0;\n  color: #374151;\n}\n\n.lesson-info-modal-content {\n  padding: 24px;\n  background: white;\n}\n\n/* Детальная информация о занятии */\n.lesson-details-info {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.info-section-header {\n  background: #f8fafc;\n  color: #002FA7;\n  margin: 0;\n  padding: 16px 20px;\n  font-size: 16px;\n  font-weight: 600;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.info-section-content {\n  padding: 14px;\n}\n\n/* ОДИНАКОВАЯ СЕТКА для деталей и статистики - 4 колонки */\n.info-grid-4 {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n}\n\n.info-grid-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 12px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  text-align: center;\n  min-height: 80px;\n  justify-content: center;\n}\n\n.info-grid-label {\n  font-size: 11px;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  line-height: 1.2;\n}\n\n.info-grid-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n/* Статистика посещаемости */\n.attendance-stats-section {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.attendance-stats-header {\n  background: #f8fafc;\n  color: #002FA7;\n  margin: 0;\n  padding: 16px 20px;\n  font-size: 16px;\n  font-weight: 600;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.attendance-stats-content {\n  padding: 20px;\n}\n\n/* Процент посещаемости - отдельный блок */\n.attendance-percentage {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 20px;\n  background: linear-gradient(135deg, #f0f4ff 0%, #e6f0ff 100%);\n  border-radius: 8px;\n  border: 1px solid #c7d2fe;\n  margin-top: 16px;\n}\n\n.percentage-circle {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  background: conic-gradient(\n    #002FA7 0% var(--percentage, 0%),\n    #f1f5f9 var(--percentage, 0%) 100%\n  );\n}\n\n.percentage-circle::before {\n  content: '';\n  position: absolute;\n  width: 56px;\n  height: 56px;\n  background: white;\n  border-radius: 50%;\n}\n\n.percentage-value {\n  font-size: 18px;\n  font-weight: 800;\n  color: #002FA7;\n  z-index: 1;\n}\n\n.percentage-label {\n  font-size: 16px;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n/* Стили для состояния загрузки */\n.lesson-info-loading {\n  text-align: center;\n  padding: 40px 20px;\n  color: #64748b;\n}\n\n.lesson-info-loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #f1f5f9;\n  border-top: 3px solid #002FA7;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 16px;\n}\n\n.lesson-info-loading-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n}\n\n/* Стили для отсутствующей информации */\n.lesson-info-no-data {\n  text-align: center;\n  padding: 40px 20px;\n  color: #64748b;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px dashed #cbd5e1;\n  margin: 20px 0;\n}\n\n.lesson-info-no-data-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  color: #cbd5e1;\n}\n\n.lesson-info-no-data h4 {\n  margin: 0 0 12px 0;\n  color: #475569;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.lesson-info-no-data p {\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* Кнопки действий */\n.lesson-info-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n}\n\n/* Анимации */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .lesson-info-modal {\n    width: 95%;\n    margin: 20px;\n    max-height: 95vh;\n  }\n  \n  .lesson-info-modal-header {\n    padding: 20px;\n  }\n  \n  .lesson-info-modal-header h3 {\n    font-size: 18px;\n  }\n  \n  .lesson-info-modal-content {\n    padding: 20px;\n  }\n  \n  .info-grid-4 {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n  \n  .info-grid-item {\n    padding: 16px 8px;\n    min-height: 70px;\n  }\n  \n  .info-grid-value {\n    font-size: 16px;\n  }\n  \n  .info-section-content,\n  .attendance-stats-content {\n    padding: 16px;\n  }\n  \n  .attendance-percentage {\n    flex-direction: column;\n    gap: 12px;\n    text-align: center;\n    padding: 16px;\n  }\n  \n  .percentage-circle {\n    width: 60px;\n    height: 60px;\n  }\n  \n  .percentage-circle::before {\n    width: 48px;\n    height: 48px;\n  }\n  \n  .percentage-value {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .lesson-info-modal-header {\n    padding: 16px;\n  }\n  \n  .lesson-info-modal-content {\n    padding: 16px;\n  }\n  \n  .info-grid-4 {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n  \n  .info-grid-item {\n    padding: 14px 8px;\n    min-height: 65px;\n  }\n  \n  .info-grid-value {\n    font-size: 16px;\n  }\n  \n  .percentage-circle {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .percentage-circle::before {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .percentage-value {\n    font-size: 14px;\n  }\n}\n\n\n/* Стили для состояния загрузки данных */\n.loading-message {\n  text-align: center;\n  padding: 60px 20px;\n  color: #64748b;\n  font-size: 16px;\n  background: white;\n  border-radius: 12px;\n  margin: 20px 0;\n  border: 1px solid #e2e8f0;\n}\n\n.no-data-message {\n  text-align: center;\n  padding: 60px 20px;\n  color: #64748b;\n  font-size: 16px;\n  background: white;\n  border-radius: 12px;\n  margin: 20px 0;\n  border: 1px solid #e2e8f0;\n}\n\n\n/* Фильтры */\n.attendance-filters {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0 8px;\n  margin-bottom: 20px;\n}\n\n.date-range-filter {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.date-range-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.date-range-label {\n  font-size: 14px;\n  font-weight: 400;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.date-range-input {\n  padding: 8px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #1e293b;\n  background: white;\n  cursor: pointer;\n  min-width: 80px;\n  transition: all 0.2s ease;\n  height: 35px;\n}\n\n.date-range-input:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n.subgroup-filter {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.filter-select {\n  padding: 8px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #1e293b;\n  background: white;\n  cursor: pointer;\n  min-width: 160px;\n  transition: all 0.2s ease;\n  height: 35px;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n/* Контейнер таблицы */\n.attendance-table-container {\n  width: 100%;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.attendance-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  position: relative;\n}\n\n.attendance-table {\n  min-width: 100%;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n\n/* При расширенном режиме увеличиваем ширину таблицы */\n.teacher-attendance-section.expanded .attendance-table,\nbody.menu-collapsed .attendance-table {\n  min-width: 1200px;\n}\n\n.attendance-table th {\n  background: white;\n  color: #002c9c;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 16px 8px;\n  text-align: center;\n  border-bottom: 1px solid #e2e8f0;\n  user-select: none;\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n  z-index: 30;\n}\n\n/* Фиксированные заголовки */\n.attendance-table th.column-number {\n  position: sticky;\n  left: 0;\n  z-index: 50;\n  background: #f8fafc;\n  border-right: 2px solid #e2e8f0;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.attendance-table th.column-name {\n  position: sticky;\n  left: 60px;\n  z-index: 50;\n  background: #f8fafc;\n  border-right: 2px solid #e2e8f0;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.attendance-table th.column-subgroup {\n  position: sticky;\n  left: 310px;\n  z-index: 50;\n  background: #f8fafc;\n  border-right: 2px solid #e2e8f0;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.attendance-table th.column-percentage {\n  position: sticky;\n  right: 0;\n  z-index: 50;\n  background: #f8fafc;\n  border-left: 2px solid #e2e8f0;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.attendance-table td {\n  padding: 12px 8px;\n  border-bottom: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  text-align: center;\n  height: 50px;\n  position: relative;\n  z-index: 1;\n}\n\n\n\n/* (аналогично успеваемости) */\n.teacher-display {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  background: #f8fafc;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n}\n\n.teacher-value {\n  font-size: 14px;\n  color: #002FA7;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.teacher-value:hover {\n  background: #f0f4ff;\n}\n\n.teacher-edit-container {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.teacher-edit-input {\n  border: 1px solid #002FA7;\n  border-radius: 4px;\n  padding: 4px 8px;\n  font-size: 14px;\n  width: 120px;\n}\n\n.teacher-edit-input:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n.teacher-save-btn,\n.teacher-cancel-btn {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  padding: 4px 6px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.2s ease;\n}\n\n.teacher-save-btn:hover {\n  background: #2cbb00;\n  color: white;\n  border-color: #2cbb00;\n}\n\n.teacher-cancel-btn:hover {\n  background: #ef4444;\n  color: white;\n  border-color: #ef4444;\n}\n\n.type-filters {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Фиксированные ячейки */\n.attendance-table td.column-number {\n  position: sticky;\n  left: 0;\n  z-index: 40;\n  background: white;\n  border-right: 2px solid #e2e8f0;\n}\n\n.attendance-table td.column-name {\n  position: sticky;\n  left: 60px;\n  z-index: 40;\n  background: white;\n  border-right: 2px solid #e2e8f0;\n  text-align: left !important;\n}\n\n.attendance-table td.column-subgroup {\n  position: sticky;\n  left: 310px;\n  z-index: 40;\n  background: white;\n  border-right: 2px solid #e2e8f0;\n}\n\n.attendance-table td.column-percentage {\n  position: sticky;\n  right: 0;\n  z-index: 40;\n  background: white;\n  border-left: 2px solid #e2e8f0;\n}\n\n/* Подсветка при наведении на строку */\n.attendance-table tbody tr:hover td.column-number,\n.attendance-table tbody tr:hover td.column-name,\n.attendance-table tbody tr:hover td.column-subgroup,\n.attendance-table tbody tr:hover td.column-percentage {\n  background: #f0f4ff;\n}\n\n/* Конкретные размеры и позиции колонок */\n.column-number {\n  width: 60px;\n  min-width: 60px;\n  max-width: 60px;\n}\n\n.column-name {\n  width: 250px;\n  min-width: 250px;\n  max-width: 250px;\n  text-align: left;\n}\n\n.column-subgroup {\n  width: 100px;\n  min-width: 100px;\n  max-width: 100px;\n}\n\n.column-date {\n  width: 80px;\n  min-width: 80px;\n  max-width: 80px;\n  cursor: pointer;\n  position: relative;\n  z-index: 1;\n}\n\n\n.column-percentage {\n  width: 120px;\n  min-width: 120px;\n  max-width: 120px;\n}\n\n/* При расширенном режиме увеличиваем ширину некоторых колонок */\n.teacher-attendance-section.expanded .column-name,\nbody.menu-collapsed .column-name {\n  width: 300px;\n  min-width: 300px;\n  max-width: 300px;\n}\n\n.teacher-attendance-section.expanded .column-date,\nbody.menu-collapsed .column-date {\n  width: 90px;\n  min-width: 90px;\n  max-width: 90px;\n}\n\n/* Стили для ячеек */\n.cell-number {\n  font-weight: 600;\n  color: #002FA7;\n  font-size: 14px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n\n.cell-name {\n  text-align: left !important;\n  padding: 12px 16px !important;\n  font-weight: 500;\n  color: #1e293b;\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cell-subgroup {\n  font-weight: 500;\n  color: #64748b;\n  font-size: 13px;\n  text-align: center;\n}\n\n.subgroup-select {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  font-size: 12px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.subgroup-select:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n/* стили для статусов посещаемости */\n.cell-status-container {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  text-align: center;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 50px;\n  width: 100%;\n}\n\n.cell-status {\n  height: 36px;\n  width: 36px;\n  border-radius: 8px;\n  font-weight: 700;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  transition: all 0.2s ease;\n  border: 2px solid transparent;\n}\n\n.cell-status-container:hover .cell-status {\n  transform: scale(1.15);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);\n}\n\n.cell-status-container.editing {\n  border: 2px solid #002FA7;\n  border-radius: 6px;\n  background: white;\n}\n\n/* Цвета для статусов */\n.status-present {\n  background: #2cbb00ff;\n}\n\n.status-absent {\n  background: #f59e0b;\n}\n\n.status-sick {\n  background: #6b7280;\n}\n\n.status-not {\n  background: #ef4444;\n}\n\n.status-empty {\n  background: transparent;\n  border: 1px solid #cbd5e1;\n  color: #cbd5e1;\n  text-shadow: none;\n}\n\n.status-empty:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n  background: #f0f4ff;\n}\n\n/* Неактивные отчисленные/переведенные студенты в списке */\n\n.student-inactive {\n  background-color: #f8f9fa;\n}\n\n.student-inactive .cell-name {\n  color: #9ca3af;\n}\n\n.inactive-badge {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 2px 6px;\n  font-size: 10px;\n  background-color: #9c9c9c;\n  color: white;\n  border-radius: 4px;\n  text-transform: uppercase;\n}\n\n.cell-status-container.disabled {\n  cursor: not-allowed;\n}\n\n.cell-status-container.disabled .cell-status {\n  opacity: 0.5;\n}\n\n/* Стили для процента посещаемости студентов */\n.cell-percentage {\n  font-weight: 600;\n  font-size: 13px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  display: inline-block;\n  min-width: 60px;\n  text-align: center;\n}\n\n/* Inputs */\n.status-input,\n.date-input {\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: transparent;\n  text-align: center;\n  font-weight: 600;\n  font-size: 13px;\n  color: #1e293b;\n  outline: none;\n}\n\n.status-input::placeholder {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.date-input::placeholder {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n/* Общая посещаемость группы */\n.group-attendance-footer {\n  padding: 16px 14px;\n  background: transparent;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.group-attendance-percentage {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 16px;\n  background: white;\n  border-radius: 50px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.percentage-circle {\n  width: 62px;\n  height: 62px;  \n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  background: conic-gradient(\n    var(--percentage-color, #002FA7) 0% var(--percentage, 0%),\n    #f1f5f9 var(--percentage, 0%) 100%\n  );\n}\n\n.percentage-circle::before {\n  content: '';\n  position: absolute;\n  width: 52px;\n  height: 52px;\n  background: white;\n  border-radius: 50%;\n  align-items: center;\n}\n\n.percentage-value {\n  font-size: 15px; \n  font-weight: 800;\n  z-index: 1;\n  color: var(--percentage-color, #002FA7);\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.percentage-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748b;\n  padding-right: 5px;\n}\n\n/* Двойной блок с процентами */\n.double-percentage-footer {\n  padding: 16px 14px;\n  background: transparent;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.double-percentage-group {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.percentage-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 16px;\n  background: white;\n  border-radius: 50px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.percentage-item-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n/* Модальные окна */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(50, 64, 124, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.modal-content {\n  background: white;\n  padding: 24px;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  min-width: 400px;\n  max-width: 500px;\n}\n\n.modal-content h3 {\n  margin: 0 0 16px 0;\n  color: #002FA7;\n  font-size: 18px;\n}\n\n.modal-content textarea {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  resize: vertical;\n  font-family: inherit;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n.modal-content textarea:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n.date-inputs {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.date-input-group {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.date-input-group label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #002FA7;\n}\n\n.date-input-group input {\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.date-input-group input:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.cancel-btn {\n  padding: 8px 16px;\n  border: 2px solid #e2e8f0;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  color: #64748b;\n  transition: all 0.2s ease;\n}\n\n.cancel-btn:hover {\n  border-color: #64748b;\n  background: #f8fafc;\n}\n\n/* Стили для скроллбара */\n.attendance-table-wrapper::-webkit-scrollbar {\n  height: 8px;\n}\n\n.attendance-table-wrapper::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n.attendance-table-wrapper::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.attendance-table-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .teacher-attendance-section {\n    width: 100%;\n    min-width: 100%;\n    padding: 12px;\n  }\n  \n  .teacher-attendance-section.expanded,\n  body.menu-collapsed .teacher-attendance-section {\n    width: 100% !important;\n  }\n  \n  .attendance-filters {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .attendance-title-container {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .attendance-actions {\n    justify-content: space-between;\n    width: 100%;\n  }\n  \n  .modal-content {\n    min-width: 90vw;\n    margin: 20px;\n  }\n  \n  .date-inputs {\n    flex-direction: column;\n  }\n  \n  .column-name {\n    width: 200px;\n    min-width: 200px;\n  }\n  \n  .column-number {\n    width: 50px;\n    min-width: 50px;\n  }\n  \n  .column-subgroup {\n    width: 80px;\n    min-width: 80px;\n  }\n  \n  .percentage-circle {\n    width: 80px;\n    height: 80px;\n  }\n  \n  .percentage-circle::before {\n    width: 64px;\n    height: 64px;\n  }\n  \n  .percentage-value {\n    font-size: 16px;\n  }\n  \n  .cell-status {\n    height: 32px;\n    width: 32px;\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
